type Image = Queries.ImageFragment | null | undefined;
type Video = Queries.muxVideoFragmentFragment | null | undefined;

export type CombinedMedia = {
  mediaArrayWithVideos: (Image | Video | null | undefined)[];
  mediaArrayWithThumbnails: (Image | (Video & { isThumbnail: boolean }) | null | undefined)[];
};

const combineMedia = ({
  mainImage,
  images,
  hdImages,
  hdMainImage,
  videos,
}: {
  mainImage: Image | null | undefined;
  images: readonly Image[] | null | undefined;
  hdImages: readonly Image[] | null | undefined;
  hdMainImage: Image | null | undefined;
  videos: readonly Video[] | null | undefined;
}) => {
  const mediaArray = [mainImage, ...(images ?? [])];
  const hdMediaArray = [hdMainImage, ...(hdImages ?? [])];
  const mediaArrayWithThumbnails: ((Video & { isThumbnail: boolean }) | Image | null)[] = [...mediaArray];
  const mediaArrayWithVideos: (Video | Image | null)[] = [...hdMediaArray];
  if (!videos || videos.length === 0)
    return {
      mediaArrayWithVideos,
      mediaArrayWithThumbnails,
    };

  const length = videos.length + mediaArray.length;
  // the order value is index + 1
  const indicesToInsert = videos.map((video) => video?.order && (video.order > length ? length - 1 : video.order - 1));
  const thumbnails = videos?.map((video) => (video?.thumbnail ? { ...video.thumbnail, isThumbnail: true } : null));

  for (let i = 0; i < videos.length; i++) {
    mediaArrayWithVideos.splice(indicesToInsert[i] ?? -1, 0, videos[i]);
    const thumbnailToInsert = thumbnails[i];
    if (thumbnailToInsert) {
      mediaArrayWithThumbnails.splice(indicesToInsert[i] ?? -1, 0, { ...thumbnailToInsert, isThumbnail: true });
    }
  }

  return {
    mediaArrayWithVideos,
    mediaArrayWithThumbnails,
  };
};

export default combineMedia;
